import { Input } from "../input";

import { getFieldError } from "./get-field-error";
import { useFieldContext } from "./form";

interface FormTextFieldProps extends Omit<
  React.ComponentProps<typeof Input>,
  "value" | "onChange" | "name"
> {
  showErrorMessage?: boolean;
}

function FormTextField({
  showErrorMessage = true,
  ...inputProps
}: FormTextFieldProps) {
  const field = useFieldContext<string>();

  return (
    <div className="flex flex-col gap-2">
      <Input
        id={field.name}
        name={field.name}
        value={field.state.value ?? ""}
        onChange={(event) => field.handleChange(event.target.value)}
        {...inputProps}
      />
      {showErrorMessage && field.state.meta.errors.length > 0 ? (
        <span className="text-sm text-destructive">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      ) : null}
    </div>
  );
}

export { FormTextField };
